<template>
  <tr>
    <td v-if="!caseDpUrl">
      {{item.caseInfo.title | NoEmpty}}
      <a :href="caseMccUrl"
         target="_blank"
         class="caseServicesLink">
        <v-icon small @click.stop=''>fa-file-invoice-dollar</v-icon>
      </a>
    </td>
    <td v-else>
      <a :href="caseDpUrl" target="_blank" @click.stop=''>
        {{item.caseInfo.title}}
      </a>
      <a :href="caseMccUrl"
         target="_blank"
         class="caseServicesLink">
        <v-icon small @click.stop=''>fa-file-invoice-dollar</v-icon>
      </a>
    </td>
    <td>
      {{item.caseInfo.status}}
    </td>
    <td>
      Created date: {{item.caseInfo.creationDatetime | DateWithMinutes | NoEmpty }}
      <br/>
      Materials received: {{item.caseInfo.receiptMaterialsDatetime | DateWithMinutes | NoEmpty }}
      <br/>
      Report validated: {{item.caseInfo.reportValidationEndedDate | DateWithMinutes | NoEmpty }}
    </td>
    <td>
      {{item.caseInfo.patientName}}
    </td>
    <td>
      <client-info :client-id="item.caseInfo.clientId"/>
    </td>
    <td>
      {{item.caseInfo.comment | NoEmpty}}
    </td>
    <td>
      <pretty-amount :amount="summaryExecutedPrice"/>
    </td>
    <td>
      <modal-case-service-log
        :case-id="item.caseInfo.id"
        :case-title="item.caseInfo.title"/>
      <restart-case-to-work-form :case-id="item.caseInfo.id"/>
    </td>
    <td>
      <services-info :log="item.log"
                     :affected-services="item.affectedServices"/>
    </td>
    <td>
      <material-list :case-info="item.caseInfo"
                     :case-anomalies="item.caseAnomalies"/>
    </td>
  </tr>
</template>

<script>
  import AsyncData from "../Ui/AsyncData";
  import ClientInfo from "../Sales/case/ClientInfo";
  import ServicesInfo from "./ServicesInfo";
  import MaterialList from "./MaterialList";
  import DateWithMinutes from '../Filters/DateWithMinutes.js'
  import NoEmpty from '../Filters/NoEmpty'
  import ModalJsonView from "../Ui/ModalJsonView";
  import ModalCaseServiceLog from "../Sales/case/ModalCaseServiceLog";
  import PrettyAmount from '../../components/Ui/PrettyAmount'
  import {calculateExecutedPrice, resolveCaseServicePageUrl, resolveDpCasePageUrl} from "./utils";
  import RestartCaseToWorkForm from "../case/RestartCaseToWorkForm";

  export default {
    name: 'analytics-data-item',
    components: {
      AsyncData,
      ServicesInfo,
      MaterialList,
      ClientInfo,
      ModalJsonView,
      ModalCaseServiceLog,
      PrettyAmount,
      RestartCaseToWorkForm,
    },
    props: {
      item: {
        type: Object,
        required: true
      }
    },
    filters: {
      NoEmpty,
      DateWithMinutes
    },
    data() {
      return {}
    },
    computed: {
      caseDpUrl() {
        if (!this.item.caseInfo.dpId) {
          return null
        }

        return resolveDpCasePageUrl(this.item.caseInfo.dpId)
      },
      caseMccUrl() {
        return resolveCaseServicePageUrl(this.$router, this.item.caseInfo.id)
      },
      summaryExecutedPrice() {
        return calculateExecutedPrice(this.item)
      }
    }
  }
</script>



// WEBPACK FOOTER //
// src/components/analytics/AnalyticsDataItem.vue